import type { TimelineStep } from '@/ui/TimelineBadgeStepper';

import type { EtapaFechamentoV2 } from '../types';

export const ETAPAS_ORDEM: EtapaFechamentoV2[] = [
  'abertura',
  'apontamento',
  'validacao',
  'processamento',
  'pagamento',
  'concluido',
];

export const ETAPA_META: Record<EtapaFechamentoV2, { label: string; sigla: string }> = {
  abertura: { label: 'Competência aberta', sigla: 'AB' },
  apontamento: { label: 'Em apontamento', sigla: 'AP' },
  validacao: { label: 'Em validação SME', sigla: 'VA' },
  processamento: { label: 'Em processamento', sigla: 'PROC' },
  pagamento: { label: 'Em pagamento', sigla: 'PAG' },
  concluido: { label: 'Pagamento efetuado', sigla: 'OK' },
};

export function construirEtapasTimeline(
  etapa: EtapaFechamentoV2,
  responsavel: string,
  proximoPasso: string,
  atrasado: boolean,
  diasParaPrazo: number,
): TimelineStep[] {
  const atual = ETAPAS_ORDEM.indexOf(etapa);
  return ETAPAS_ORDEM.map((e, i) => {
    const meta = ETAPA_META[e];
    const isAtual = i === atual && etapa !== 'concluido';
    return {
      sigla: meta.sigla,
      label: meta.label,
      status:
        i < atual || (etapa === 'concluido' && i === atual)
          ? 'completed'
          : isAtual
            ? atrasado
              ? 'error'
              : 'current'
            : 'pending',
      responsavel: isAtual ? responsavel : undefined,
      slaLabel: isAtual
        ? atrasado
          ? `${Math.abs(diasParaPrazo)}d em atraso`
          : `em ${diasParaPrazo}d`
        : undefined,
      proximaAcao: isAtual ? proximoPasso : undefined,
    };
  });
}
